const getLatestInternalComment = internalComments => {
  return internalComments?.[(internalComments?.length ?? 0) - 1]?.comment ?? "";
};

export default getLatestInternalComment;
